import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

export const initState = {
  full: [],
  passages: [],
  questions: [],
  audioAssets: [],
  linebreakMarks: [],
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_FULL_CURRICULUM:
      return {
        ...state,
        full: payload.fullCurriculum,
      };

    case REDUX_ACTIONS.SET_LEVEL_CURRICULUM:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
